const base = process.env.PUBLIC_URL || "";
const reduceMotion = () =>
  typeof window !== "undefined"
  && window.matchMedia
  && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function AppShot({ src, video, poster, alt, label, caption, testId, wide = false }) {
  const showVideo = Boolean(video) && !reduceMotion();
  return (
    <figure className={`app-shot landing-reveal${wide ? " is-wide" : ""}`} data-testid={testId}>
      <div className="app-shot-frame">
        <span className="app-shot-tick is-tl" aria-hidden="true" />
        <span className="app-shot-tick is-tr" aria-hidden="true" />
        <span className="app-shot-tick is-bl" aria-hidden="true" />
        <span className="app-shot-tick is-br" aria-hidden="true" />
        {label && <span className="app-shot-label">{label}</span>}
        {showVideo ? (
          <video
            className="app-shot-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster={`${base}/landing/${poster}`}
            aria-label={alt}
            data-testid={`${testId}-video`}
          >
            <source src={`${base}/landing/${video}.mp4`} type="video/mp4" />
            <source src={`${base}/landing/${video}.webm`} type="video/webm" />
            <img src={`${base}/landing/${poster || src}`} alt={alt} />
          </video>
        ) : (
          <img src={`${base}/landing/${video ? poster : src}`} alt={alt} loading="lazy" />
        )}
      </div>
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
